module.exports = new __parcel__URL__("post-default-gold.a9486504.jpg").toString();